import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Monogram from "./Monogram";

const LINKS = [
  { label: "Countdown", id: "#countdown" },
  { label: "Our Story", id: "#story" },
  { label: "Celebrations", id: "#celebrations" },
  { label: "Details", id: "#details" },
  { label: "RSVP", id: "#rsvp" },
];

const EASE = [0.16, 1, 0.3, 1];

export default function Nav({ onNav, ready }) {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    setTimeout(() => onNav(id), open ? 320 : 0);
  };

  return (
    <>
      <motion.nav
        className="nav"
        data-testid="nav-bar"
        initial={{ opacity: 0 }}
        animate={{ opacity: ready ? 1 : 0 }}
        transition={{ duration: 0.8, delay: 0.5 }}
      >
        <button
          className="nav-brand"
          data-testid="nav-brand"
          onClick={() => go("#top")}
        >
          <Monogram size={30} />
          <span>D &amp; D</span>
        </button>
        <div className="nav-links">
          {LINKS.map((l) => (
            <button key={l.id} data-testid={`nav-link-${l.id.slice(1)}`} onClick={() => go(l.id)}>
              {l.label}
            </button>
          ))}
        </div>
        <button
          className="nav-menu-btn"
          data-testid="menu-open-button"
          onClick={() => setOpen(true)}
        >
          Menu
        </button>
      </motion.nav>

      <AnimatePresence>
        {open && (
          <motion.div
            className="menu-overlay"
            data-testid="menu-overlay"
            initial={{ y: "-100%" }}
            animate={{ y: 0 }}
            exit={{ y: "-100%" }}
            transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1] }}
          >
            <button
              className="menu-close"
              data-testid="menu-close-button"
              onClick={() => setOpen(false)}
            >
              Close
            </button>
            {LINKS.map((l, i) => (
              <motion.button
                key={l.id}
                className="menu-link"
                data-testid={`menu-link-${l.id.slice(1)}`}
                initial={{ opacity: 0, y: 28 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, ease: EASE, delay: 0.15 + i * 0.07 }}
                onClick={() => go(l.id)}
              >
                <span className="menu-idx">0{i + 1}</span>
                {l.label}
              </motion.button>
            ))}
            <div className="menu-overlay-date kicker">26 · 11 · 2026 — Kanpur</div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
